export interface SiteConfig {
  mainText: string;
  subText: string;
  imgLink: string;
  mainTextColor: string;
  title: string;
  mapLink: string;
  addrLine1: string;
  addrLine2: string;
  addrLine3: string;
  emailId: string;
  contactNo: string;
}

export const siteConfig: SiteConfig = {
  mainText: 'Stay Tuned',
  subText: 'Our website is almost ready and we will launch it soon',
  imgLink: 'logo.svg',
  mainTextColor: '#00d5ab',
  title: 'Connfido',
  mapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2435.1540377607594!2d4.919473715975684!3d52.38575785392122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c60995a2ff6df1%3A0x8852628be85edc7a!2sPand%20Noord!5e0!3m2!1sen!2sin!4v1571739169051!5m2!1sen!2sin',
  addrLine1: 'Meeuwenlaan 98-100,',
  addrLine2: '1021 JL Amsterdam',
  addrLine3: 'The Netherlands',
  emailId: 'info@connfido.com',
  contactNo: '+31858769806',
};
